const generateMailTo = (recipient: string, subject: string, body: string) =>
  `mailto:${recipient}?subject=${prepareForMail(subject)}&body=${prepareForMail(body)}`;

const prepareForMail = (value: string) => {
  const space = '%20';
  const br = '%0D%0A';
  return encodeURIComponent(value).replace(' ', space).replace('\n', br);
};

export { generateMailTo };
